import { isRouteExists } from "@/modules/pe-basic-module/data/isRouteChildren"
import { IMenuItem, WINDOW_WIDTH } from "@libs/interfaces/layouts"
import { routing, template } from "@libs/layouts"
import { Gallery } from "src/libs/useful"
import { NAVIGATION_POSITION_TYPE } from "src/libs/useful/gallery/Gallery"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import FooterMenuItem from "./FooterMenuItem"

/* Protopia Ecosystem component */
const FooterMenu = (): JSX.Element => {
    const {width} = useScreenSize()
    if( !template().footer || !routing()?.footer || !Object.keys(routing().footer).length ) return <></>
    return width > WINDOW_WIDTH.MOBILE 
        ?
        <FooterMenuScreen />
        :
        <FooterMenuMobile />
}
export default FooterMenu

const FooterMenuScreen = (): JSX.Element => {
    
    // console.table({ footer: Object.keys(routing().footer).map( key => JSON.stringify(routing().footer[key] )), count: Object.keys(routing().footer).length })
    const items: IMenuItem[] = Object.keys( routing()?.footer )
        .filter((key) => {
            const item:IMenuItem = routing().footer[key]
            return  isRouteExists(item)
        })
        .map(key => ( routing().footer )[key] )

    // console.table({ footer: Object.keys(items).map( (key, i) => JSON.stringify(items[i] )), count: Object.keys(items).length })
    

    return items?.length
        ? 
        <div className="d-flex flex-centered pe-footer-menu-container" data-testid="pe-footer-menu-container"> 
            {
                items.map((item: IMenuItem) => <FooterMenuItem item={item} key={item.id} /> )                
            } 
        </div> 
        :
        <></>
}

const FooterMenuMobile = (): JSX.Element => {
    
    // console.table({ footer: Object.keys(routing().footer).map( key => JSON.stringify(routing().footer[key] )), count: Object.keys(routing().footer).length })
    const items: IMenuItem[] = Object.keys( routing()?.footer )
        .filter((key) => {
            const item:IMenuItem = routing().footer[key]
            return  isRouteExists(item)
        })
        .map(key => ( routing().footer )[key] )

    // console.table({ footer: Object.keys(items).map( (key, i) => JSON.stringify(items[i] )), count: Object.keys(items).length })
    

    return items?.length
        ? 
        <div className="d-flex flex-centered pe-footer-menu-container" data-testid="pe-footer-menu-container"> 
            {
                <Gallery 
                    items={ items.map((item: IMenuItem) => <FooterMenuItem item={item} key={item.id} /> )     } 
                    itemWidth="100%"                
                    itemHeight={ 25 } 
                    pagination={ false }
                    navigation={ true }
                    navigationPositionType={ NAVIGATION_POSITION_TYPE.MIDDLE_INNER} 
                    count={ 1 }
                    loop
                    autoplay={6000}
                    type="element"
                    padding={ 30 }
                />  
            } 
        </div> 
        :
        <></>
}